module.exports = __webpack_public_path__ + "img/cuidado.0b980c6b.jpeg";